<div class="container-fluid">
  <div class="row">

    <mat-card class="col-sm-12">

      <mat-tab-group class="myTabs">

          <!-- Tab 1 -->
          <mat-tab label="System State and Provisioning">
          <mat-card-content >
            <div class="col-sm-12 text-center" *ngIf="endpoint_data">
              <system-state-provisioning-component></system-state-provisioning-component>
            </div>
          </mat-card-content>
        </mat-tab>
        <!-- End Tab 1 -->

        <!-- Tab 2 -->
        <mat-tab label="System Settings" >
          <mat-card-content>
            <div class="col-sm-12" *ngIf="endpoint_data">
              <system-setting-component></system-setting-component>
            </div>
          </mat-card-content>
        </mat-tab>
        <!-- End Tab 2 -->


        <!-- Tab 3 -->
        <mat-tab label="Update System" *ngIf="adminAuthorization">
          <mat-card-content >
            <div class="col-sm-12 text-center" *ngIf="endpoint_data">
              <system-update></system-update>
            </div>
          </mat-card-content>
        </mat-tab>
        <!-- End Tab 3 -->


        <!-- Tab 4 -->
        <mat-tab label="Change System Location and Password" *ngIf="adminAuthorization">
          <mat-card-content >
            <div class="col-sm-12 text-center" *ngIf="endpoint_data">
              <system-location-password-component
               [selected_parent_folder]="selected_parent_folder"
                [selected_folder]="selected_folder"
                (endPoint_location_updated)="informParentToRefetchData($event)">
              </system-location-password-component>
            </div>
          </mat-card-content>
        </mat-tab>
        <!-- End Tab 4 -->


        <!-- Tab 0 -->
        <mat-tab label="Folder Systems State">
          <mat-card-content >
            <div class="col-sm-12 text-center" *ngIf="!selected_folder">
              <h3 style="color: green;">No folder was selected from tree</h3>
            </div>
            <div class="col-sm-12 text-center" *ngIf="selected_folder">
              <folder-systems-component [selected_folder]="selected_folder?.value"></folder-systems-component>
            </div>
          </mat-card-content>
        </mat-tab>
        <!-- End Tab 0 -->


                <!-- Tab 0 -->
        <!-- <mat-tab label="Systems Report Generator">
          <mat-card-content >
            <div class="col-sm-12 text-center" *ngIf="!selected_folder">
              <h3 style="color: green;">No folder was selected from tree</h3>
            </div>
            <div class="col-sm-12 text-center" *ngIf="selected_folder">
              <folder-systems-component [selected_folder]="selected_folder?.value"></folder-systems-component>
            </div>
          </mat-card-content>
        </mat-tab> -->
        <!-- End Tab 0 -->


      </mat-tab-group>

    </mat-card>

  </div>
</div>
